import React, { useEffect, useState } from "react";
import SettingClasses from "./Settings.module.css";
import Load from "Components/Loader/loader";
import { useForm, SubmitHandler } from "react-hook-form";
import { showSuccessNotification } from "Utils/Notifications";
import { showSuccessAlert, showWarningAlert } from "Utils/Alerts";
import { change_password } from "Services/Requests";
// import { Interface } from "readline";
interface Inputs {
    orginal_password: string;
    new_password: string;
    confirm_passeord: string;
}
function Settings() {
    // const [Active, SetActive] = useState("edit-profile");
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>();
    const [userDetails, setUserDetails] = useState<any>();
    useEffect(() => {
        let userData = localStorage.getItem("UserDetails");
        if (userData) {
            setUserDetails(JSON.parse(userData));
        }
    }, []);
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (data.confirm_passeord != data.new_password) {
            showWarningAlert(
                "New password and confirm password mismatch please try again"
            );
            return;
        }
        setLoading(true);
        try {
            const response = await change_password(data);
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessAlert("Password changed Successfully");
                reset();
            } else {
                showWarningAlert(
                    response?.data.Message || "Something went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    return (
        <div className={SettingClasses["wrapper"]}>
            {loading && <Load />}

            <div className={SettingClasses["Container"]}>
         
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h3>Change Password</h3>
                    <div className={SettingClasses["edit"]}>
                        <div className={SettingClasses["form-control"]}>
                            <label htmlFor="">Email</label>
                            <input
                                type="email"
                                placeholder="Enter Email"
                                disabled
                                value={userDetails?.email}
                            />
                        </div>
                        <div className={SettingClasses["form-control"]}>
                            <label htmlFor="">Current Password</label>
                            <input
                                type="password"
                                placeholder="Enter Current password"
                                className={
                                    errors?.orginal_password &&
                                    SettingClasses["error-input"]
                                }
                                {...register("orginal_password", {
                                    required: true,
                                })}
                            />
                            {errors?.orginal_password && (
                                <p>This is required </p>
                            )}
                        </div>
                        <div className={SettingClasses["form-control"]}>
                            <label htmlFor="">New Password</label>
                            <input
                                type="password"
                                placeholder="Enter New password"
                                className={
                                    errors?.new_password &&
                                    SettingClasses["error-input"]
                                }
                                {...register("new_password", {
                                    required: true,
                                })}
                            />
                            {errors?.new_password && <p>This is required </p>}
                        </div>
                        <div className={SettingClasses["form-control"]}>
                            <label htmlFor="">Confirm Password</label>
                            <input
                                type="password"
                                placeholder="Enter Confirm password"
                                className={
                                    errors?.confirm_passeord &&
                                    SettingClasses["error-input"]
                                }
                                {...register("confirm_passeord", {
                                    required: true,
                                })}
                            />
                            {errors?.confirm_passeord && (
                                <p>This is required </p>
                            )}
                        </div>
                    </div>
                    <button>Save Changes</button>
                </form>
            </div>
        </div>
    );
}

export default Settings;
